import { client } from "./request";

export interface ProjectDefaultProfitRate {
  profitRate: number;
}

/**
 * 現場の発注者から利益率の初期値を得る
 */
export async function getProjectDefaultProfitRate(
  projectId: string
): Promise<ProjectDefaultProfitRate> {
  const project = await client.get("get_project_default_profit_rate.php", {
    projectId
  });
  return {
    profitRate:
      project.profitRate === null
        ? project.defaultProfitRate
        : project.profitRate
  };
}
